'use client';

import { type NodeProps } from '@xyflow/react';
import { NodeShell } from '../BaseNode';
import { usePipelineStore } from '@/lib/pipeline/store';
import { ParamNameField } from '../ParamNameField';
import { MirroredInput } from '../MirroredInput';

export default function NumberNode({ id, data }: NodeProps) {
  const update = usePipelineStore((s) => s.updateNodeData);
  const d = data as { value?: number; param?: string | null };

  return (
    <NodeShell id={id} type="numberInput">
      <label className="text-[11px] text-[var(--text-muted)] block">
        Value
        <MirroredInput
          type="number"
          className="input nodrag w-full text-xs mt-0.5"
          value={d.value ?? 0}
          onCommit={(v) => update(id, { value: v === '' ? 0 : Number(v) })}
        />
      </label>
      <ParamNameField id={id} value={d.param} />
    </NodeShell>
  );
}
